angular.module('impactx.beco').controller('BecoCancelVChargeListCtrl', BecoCancelVChargeListCtrl);

function BecoCancelVChargeListCtrl() {
    this.meta = {
        rowTemplate: 'modules/beco/templates/beco.row.html',
        isSelectAble: false,
        endpoint: '/beco/cancelvcharge',
        ctrl: this,
        id: "becocancelvchargelist",
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    };
}